export const CONTENT_MODAL_WIDTH = 800;
export const HERO_IMG_HEIGHT = 450; // this should keep a 16:9 aspect ration with the above value
export const MENTIONS_MARK_HIGHLIGHT_STYLE = "background-color: transparent; color: #3B78AB;";